import CoreUtils from '../../common/utils/CoreUtils';

import EnergyValueMask from '../../common/value-types/EnergyValueMask';
import MetadataHelper from '../../common/value-types/MetadataHelper';

import CorePropertyHelper from './CorePropertyHelper';

import ScheduleFieldValueOverrideRenderer from '../ScheduleFieldValueOverrideRenderer';

export default class BasicPropertyHelper {
  static onPropertyCreating(schedule, dataField, hourTypeCode, value, utcElectionCutoff) {
    var metadataField = MetadataHelper.resolveMetadataField(dataField);

    schedule[dataField] = value;

    schedule[metadataField] = {
      dataField: dataField,
      hourTypeCode: hourTypeCode,
      originalValue: value,
      electionCutoffs: [
        CorePropertyHelper.createElectionCutoff(utcElectionCutoff)
      ],
      modifiedMask: new EnergyValueMask(false),
      overriddenMask: new EnergyValueMask(false),
      overriddenTime: null,
      overriddenByUser: null,
      overrideContentRender: null,
      validationContentRender: null
    };
  }

  static onPropertyEditing(schedule, dataField, dataFieldHints, updatedDataFields) {
    var metadataField = MetadataHelper.resolveMetadataField(dataField);
    if (CoreUtils.isUndefinedOrNull(schedule[metadataField]))
      return;

    if (dataFieldHints.indexOf(dataField) !== -1) {
      schedule[metadataField].modifiedMask = new EnergyValueMask(schedule[dataField] !== schedule[metadataField].originalValue);
      schedule[metadataField].overriddenMask = new EnergyValueMask(false);
      schedule[metadataField].overriddenTime = null;
      schedule[metadataField].overriddenByUser = null;
      schedule[metadataField].overrideContentRender = null;

      updatedDataFields.push(dataField);
    }

    if (schedule[metadataField].modifiedMask.any)
      schedule.isScheduleModified = true;
  }

  static onPropertyModifying(schedule, dataField, defaultValue, scheduleUpdateSet, updatedDataFields, locale) {
    var propertyUpdateValue = scheduleUpdateSet.values[dataField];

    BasicPropertyHelper.onPropertyServerUpdate(
      schedule,
      dataField,
      propertyUpdateValue !== undefined ? propertyUpdateValue : defaultValue,
      false,
      false,
      updatedDataFields,
      locale
    );
  }

  static onPropertyServerUpdate(schedule, dataField, value, isServerUpdate, isPeerUpdate, updatedDataFields, locale) {
    var metadataField = MetadataHelper.resolveMetadataField(dataField);
    if (CoreUtils.isUndefinedOrNull(schedule[metadataField]))
      return;

    var fieldUpdated = false;

    if (value !== schedule[dataField]) {
      schedule[dataField] = value;

      var overriddenMask = new EnergyValueMask(isPeerUpdate);

      if (!overriddenMask.equals(schedule[metadataField].overriddenMask))
        schedule[metadataField].overriddenMask = overriddenMask;

      if (isPeerUpdate) {
        schedule[metadataField].overriddenTime = schedule.lastUpdatedTime;
        schedule[metadataField].overriddenByUser = schedule.lastUpdatedUser;
        schedule[metadataField].overrideContentRender = () => ScheduleFieldValueOverrideRenderer(
          schedule[metadataField].overriddenByUser,
          schedule[metadataField].overriddenTime,
          locale
        );
      } else {
        schedule[metadataField].overriddenTime = null;
        schedule[metadataField].overriddenByUser = null;
        schedule[metadataField].overrideContentRender = null;
      }

      fieldUpdated = true;
    }

    if (isServerUpdate)
      schedule[metadataField].originalValue = schedule[dataField];

    var modifiedMask = new EnergyValueMask(schedule[dataField] !== schedule[metadataField].originalValue);
    if (!modifiedMask.equals(schedule[metadataField].modifiedMask)) {
      schedule[metadataField].modifiedMask = modifiedMask;
      fieldUpdated = true;
    }

    if (fieldUpdated)
      updatedDataFields.push(dataField);

    if (schedule[metadataField].modifiedMask.any)
      schedule.isScheduleModified = true;
  }

  static onPropertyReverting(schedule, dataField, updatedDataFields) {
    var metadataField = MetadataHelper.resolveMetadataField(dataField);
    if (CoreUtils.isUndefinedOrNull(schedule[metadataField]))
      return;

    if (schedule[dataField] !== schedule[metadataField].originalValue) {
      schedule[dataField] = schedule[metadataField].originalValue;

      updatedDataFields.push(dataField);
    }

    schedule[metadataField].modifiedMask = new EnergyValueMask(false);
    schedule[metadataField].overriddenMask = new EnergyValueMask(false);
    schedule[metadataField].overriddenTime = null;
    schedule[metadataField].overriddenByUser = null;
    schedule[metadataField].overrideContentRender = null;
  }

  static onPropertyCutoffCheck(schedule, dataField, updatedDataFields, serverUtcTimeMs, warningPeriodMs) {
    var metadataField = MetadataHelper.resolveMetadataField(dataField);
    if (CoreUtils.isUndefinedOrNull(schedule[metadataField]))
      return;

    var cutoffStatusFlags = {
      cutOffStatusChanged: false,
      revertModifiedValues: false
    };

    CorePropertyHelper.processElectionCutoff(
      schedule[metadataField].electionCutoffs[0],
      serverUtcTimeMs,
      warningPeriodMs,
      cutoffStatusFlags
    );

    if (cutoffStatusFlags.revertModifiedValues && schedule[metadataField].modifiedMask.any) {
      schedule[dataField] = schedule[metadataField].originalValue;

      schedule[metadataField].modifiedMask = new EnergyValueMask(false);
      schedule[metadataField].overriddenMask = new EnergyValueMask(false);
      schedule[metadataField].overriddenTime = null;
      schedule[metadataField].overriddenByUser = null;
      schedule[metadataField].overrideContentRender = null;
    }

    if (cutoffStatusFlags.cutOffStatusChanged)
      updatedDataFields.push(dataField);

    if (schedule[metadataField].modifiedMask.any)
      schedule.isScheduleModified = true;

    if (!schedule[metadataField].electionCutoffs[0].isPastElectionCutoff)
      schedule.isCompletelyPastCutoff = false;
  }
}